global.webistePagePlanList = global.API_WEBSITE_URL+'webistePlanList/';
global.webistePageblogCategoryList = global.API_WEBSITE_URL+'blogCatgeoryList/';
global.webistePageBlogList = global.API_WEBSITE_URL+'blogList/';
global.webistePageBlogDetailsList = global.API_WEBSITE_URL+'blogDetailsWeb/';


